import ComponentToast from 'components/utils/Toast';

function successHandling(message: string): void {
  ComponentToast({
    title: message,
    type: 'success',
  });
}

export default successHandling;
